import type { StopAddress} from '../google-maps';
import {getStopAddress, makeStopKey, stopIsValid} from '../google-maps'
import {postJson, resolveRoute} from '../helpers/ajax'
import {Deferred} from '../util/deferred'


const LAT_LNG_CACHE = new Map<string,Promise<PlaceLatLng>>

export function getLatLngForStops(stops: StopAddress[]): Promise<PlaceLatLng>[] {
    const promises: Promise<PlaceLatLng>[] = new Array(stops.length)
    const needPos: {address:StopAddress,deferred:Deferred<PlaceLatLng>}[] = []
    for(const [i,stop] of stops.entries()) {
        if(!stopIsValid(stop)) {
            promises[i] = Promise.reject(new Error("Invalid stop"))
            continue
        }
        const cacheKey = makeStopKey(stop)
        if(LAT_LNG_CACHE.has(cacheKey)) {
            promises[i] = LAT_LNG_CACHE.get(cacheKey)!
            continue
        }
        const deferred = new Deferred<PlaceLatLng>()
        promises[i] = deferred.promise
        needPos.push({
            address: getStopAddress(stop),
            deferred: deferred,
        })
    }
    if(needPos.length) {
        postJson<GetLatLngResponse>(resolveRoute('bookings.getLatLng'), {stops: needPos.map(s => s.address)}).then(res => {
            if(!(res.ok && res.data.places?.length === needPos.length)) {
                for(const p of needPos) {
                    p.deferred.reject(new Error("Bad response"))
                }
            } else {
                for(let i=0; i<needPos.length; ++i) {
                    needPos[i].deferred.resolve(res.data.places[i])
                }
            }
        })
    }
    return promises
}

export interface PlaceLatLng {
    id?: number
    place_id?: string
    lat: number
    lng: number
}

export interface GetLatLngResponse {
    places: PlaceLatLng[]
}
